import * as React from 'react';
import * as IDatabase from '../../../types/database';
import { History } from 'history';
import { IDatabaseSetupSession } from './index';

import tabsImage from '../../../images/layout-tab.png'
import columnLayoutImage from '../../../images/layout-column.png'
import './styles.css';
import { FormattedMessage, InjectedIntlProps, injectIntl, defineMessages } from 'react-intl';

export interface IState {
    layout: string;
    selectedSections: IDatabase.ISection[];
    allowAttachments: boolean | null;
}
interface IProps {
    handleSave: (state: IState) => void;
    getSavedSession: () => Promise<IDatabaseSetupSession | null>;
    history: History;
    renderNextStepLink: (onClick: () => boolean) => any;
    handleCancel: () => void;
}

class Layout extends React.Component<IProps & InjectedIntlProps, IState> {
    state: IState = {
        layout: 'two',
        selectedSections: [],
        allowAttachments: null,
    };

    messages = defineMessages({
        yes: {
            id: 'db.layout.yes',
            defaultMessage: 'Yes'
        },
        no: {
            id: 'db.layout.no',
            defaultMessage: 'No'
        },
        sectionsLayout: {
            id: 'db.layout.style.sections',
            defaultMessage: 'Layout sections vertically'
        },
        tabsLayout: {
            id: 'db.layout.style.tabs',
            defaultMessage: 'Layout sections in horizontal tabs'
        }
    });

    async componentDidMount() {
        const session = await this.props.getSavedSession();
        let selectedSections: IDatabase.ISection[] = [];
        if (
            session &&
            session.fields &&
            session.fields &&
            session.fields.selected &&
            session.fields.selected &&
            Array.isArray(session.fields.selected)
        ) {
            selectedSections = session.fields.selected;
        }
        if (session && session.layout) {
            this.setState({ ...session.layout, selectedSections });
        } else {
            this.setState({ selectedSections });
        }
    }

    handleGoBack = () => {
        this.props.history.goBack();
    }

    handleSave = (): boolean => {
        this.props.handleSave({ ...this.state });
        return true;
    }

    handleBooleanInputChange = (event: any) => {
        window.onbeforeunload = () => {
            return true;
        };
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (value === 'yes') value = true;
        else if (value === 'no') value = false;
        else value = null;
        /* tslint:disable */
        const x = {};
        x[name] = value;
        this.setState(x, () => console.log(this.state));
        /* tslint:enable */
    }

    handleLayoutChange = (item: string) => {
        window.onbeforeunload = () => {
            return true;
        };
        this.setState({ layout: item });
    }

    renderSectionHeader = (name: string, index: string, i: number) => {
        if (index !== 'one') {
            const id = name.replace(' ', '-')
            return <a key={`${name}-${index}-${i}`} className={`nav-link ${i === 0 && 'active'}`} id={`v-pills-${id}-tab`} data-toggle="pill" href={`#v-pills-${id}`} role="tab" aria-controls={`v-pills-${id}`} aria-selected="true">{name}</a>
        }
        return <h2 key={`${name}-${index}-${i}`}>{name}</h2>
    }

    renderFieldHeader = (name: string, index: string) => {
        return <h2 key={`${name}-${index}`}>{name}</h2>
    }

    renderTabContent = (section: IDatabase.ISection, index: string, i: number) => {
        const id = section.name.replace(' ', '-')
        return <div key={`${id}-${index}`} className={`tab-pane fade show info-section ${i === 0 && 'active'}`} id={`v-pills-${id}`} role="tabpanel" aria-labelledby={`v-pills-${id}-tab`}>
            <div className="info-page-sec">
                <ul>
                    {section.fields.map(x => <li key={x.name}>{x.label}</li>)}
                </ul>
            </div>
        </div>
    }

    renderSection = (section: IDatabase.ISection, index: string) => {
        return (
            <div key={`section-${section.id}`} className="info-section">
                {this.renderFieldHeader(section.name, index)}

                <div className="info-page-sec">
                    <ul>
                        {section.fields.map(x => (
                            <li key={x.name}>{x.label}</li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    };

    renderSections = () => {
        const { layout: index, selectedSections } = this.state
        if (this.state.layout !== 'one') {
            return (
                <div className="row">
                    <div className="col">
                        <div className="nav nav-pills mb-3" id="v-pills-tab" role="tablist">
                            {selectedSections.map((x, i) => this.renderSectionHeader(x.name, index, i))}
                        </div>
                        <div className="tab-content" id="v-pills-tabContent">
                            {this.state.selectedSections.map((z, i) => this.renderTabContent(z, index, i))}
                        </div>
                    </div>
                </div>
            )
        }
        return this.state.selectedSections.map(x => this.renderSection(x, this.state.layout))
    }

    render() {
        return (
            <div>
                <div className="row px-2">
                    <FormattedMessage tagName="h5" id="db.layout.hdr" defaultMessage="4. Information Page Settings" />
                </div>
                <div className="row text-muted px-2 py-2">
                    <p><FormattedMessage id="db.layout.txt" defaultMessage={`
                        Please select an information page layout template. 
                        This will determine how people view information pages in your database.
                    `} />
                    </p>
                </div>

                <div className="pt-3 row">
                    <ul className="pagesettingList col">
                        {/* <li
                            key="pageLayout1"
                            onClick={() => this.handleLayoutChange('one')}
                            className={this.state.layout === 'one' ? 'act' : ''}>
                            <img src={sectionImage} alt={this.props.intl.formatMessage(this.messages.sectionsLayout)} title={this.props.intl.formatMessage(this.messages.sectionsLayout)} />
                        </li> */}
                        <li
                            key="columnLayout"
                            onClick={() => this.handleLayoutChange('columns')}
                            className={this.state.layout === 'columns' ? 'act' : ''}>
                            <img src={columnLayoutImage} alt={'Two Column Layout'} title={'Two Column Layout'} style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                            <small className="text-muted">Two Columns</small>
                        </li>
                        <li
                            key="pageLayout2"
                            onClick={() => this.handleLayoutChange('two')}
                            className={this.state.layout === 'two' ? 'act' : ''}>
                            <img src={tabsImage} alt={this.props.intl.formatMessage(this.messages.tabsLayout)} title={this.props.intl.formatMessage(this.messages.tabsLayout)} style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                            <small className="text-muted">Standard Tabs</small>
                        </li>
                        <li
                            key="bigbuddy"
                            onClick={() => this.handleLayoutChange('bigbuddy')}
                            className={this.state.layout === 'bigbuddy' ? 'act' : ''}>
                            <img src={tabsImage} alt={'Big Buddy Layout'} title={'Big Buddy Layout'} style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                            <small className="text-muted">Big Buddy</small>
                        </li>
                        <li
                            key="brayn"
                            onClick={() => this.handleLayoutChange('brayn')}
                            className={this.state.layout === 'brayn' ? 'act' : ''}>
                            <img src={tabsImage} alt={'BRAYN'} title={'BRAYN Layout'} style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                            <small className="text-muted">BRAYN</small>
                        </li>
                        <li
                            key="customOne"
                            onClick={() => this.handleLayoutChange('customOne')}
                            className={this.state.layout === 'customOne' ? 'act' : ''}>
                            <img src={tabsImage} alt={'customOne'} title={'customOne Layout'} style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                            <small className="text-muted">customOne</small>
                        </li>
                    </ul>
                </div>
                <div className="attachmentRt">
                    <div className="attachmentinnerrt">
                        <div className="pageTitleSec">
                            <div className="titleimg" />
                        </div>
                        <div className="pageconetnsec">
                            <h4><FormattedMessage id="db.layout.title" defaultMessage="Page Title" /></h4>
                            {this.renderSections()}
                        </div>
                    </div>
                </div>
                <div className="formContainer">
                    <h3><FormattedMessage id="db.layout.attachments" defaultMessage="Attachments" /></h3>
                    <div className="formInnerCol generalinfo">
                        <p><FormattedMessage id="db.layout.attachments.txt" defaultMessage={
                            `Attachments are downloadable files associated with information pages (such as 
                            documents, pictures, informational flyers, etc.). All attachments will be 
                            displayed at the bottom of the page.`} /></p>
                        <div className="row">
                            <div className="col-7">
                                <div className="form-group">
                                    <div><FormattedMessage id="db.layout.attachments.allow" defaultMessage="Allow partners to upload attachments" /></div>
                                    <div className="form-check float-sm-left">
                                        <input
                                            className="form-check-input"
                                            name="allowAttachments"
                                            type="radio"
                                            id="required-yes"
                                            value="yes"
                                            onChange={this.handleBooleanInputChange}
                                            checked={this.state.allowAttachments === true}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="required-yes">
                                            {this.props.intl.formatMessage(this.messages.yes)}
                                        </label>
                                    </div>
                                    <div className="form-check float-sm-left ml-sm-3">
                                        <input
                                            className="form-check-input"
                                            id="required-no"
                                            name="allowAttachments"
                                            type="radio"
                                            value="no"
                                            onChange={this.handleBooleanInputChange}
                                            checked={this.state.allowAttachments === false}
                                        />
                                        <label className="form-check-label" htmlFor="required-no">
                                            {this.props.intl.formatMessage(this.messages.no)}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                {/* <p>
                                    <small>
                                        <FormattedMessage id="db.layout.attachments.help" defaultMessage={`
                                        `} />
                                    </small>
                                </p> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row border-top mt-5">
                    {this.props.renderNextStepLink(this.handleSave)}
                    <button className="primary-inv" onClick={this.handleGoBack}>
                        <FormattedMessage id="db.layout.back" defaultMessage="Back" />
                    </button>
                    <button className="btn btn-link" onClick={this.props.handleCancel}><FormattedMessage id="db.layout.cancel" defaultMessage="Cancel" /></button>
                </div>
            </div>
        );
    }
}
export default injectIntl(Layout);


// WEBPACK FOOTER //
// ./src/client/database/setup/Layout.tsx